import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import axios from "axios";

import {
  Modal,
  Fade,
  Paper,
  FormControl,
  InputLabel,
  TextField,
  Button,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Store } from "react-notifications-component";

import * as actions from "../../redux/actions/index";
import { config, LOCATION_AUTH } from "../../config/config";

const AddStoreModal = ({ open, close, transaction, selectedStore }) => {
  const dispatch = useDispatch();
  const { control, setValue, handleSubmit } = useForm();
  const [cities, setCities] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedProvinces, setSelectedProvinces] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  useEffect(() => {
    if (transaction && transaction.receipt_merchant_address) {
      setValue("merchantAddressForm", transaction.receipt_merchant_address);
    } else {
      setValue("merchantAddressForm", "");
    }
    if (selectedStore) {
      setValue("storeName", selectedStore.name + " - " + "{enter-branch-name}");
    } else {
      setValue("storeName", "No store selected");
    }
    if (selectedStore && selectedStore.name) {
      setValue("selectedStore", selectedStore.name);
    }
  }, [transaction, setValue, selectedStore]);

  useEffect(() => {
    const fetchProvince = async (code) => {
      try {
        const response = await axios.get(
          `${config.geoProvinces}&code=${code}`,
          LOCATION_AUTH
        );
        setSelectedProvinces(response.data.data[0]);
      } catch (err) {
        console.log(err);
      }
    };

    if (selectedCity?.province_code) {
      fetchProvince(selectedCity.province_code);
    }
  }, [selectedCity]);

  useEffect(() => {
    const fetchRegions = async (code) => {
      try {
        const response = await axios.get(
          `${config.geoRegions}&code=${code}`,
          LOCATION_AUTH
        );
        setSelectedRegion(response.data.data[0]);
      } catch (err) {
        console.error(err, err.response.data);
      }
    };

    if (selectedProvinces?.region_code) {
      fetchRegions(selectedProvinces.region_code);
    }
  }, [selectedProvinces]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${config.geoCities}`, LOCATION_AUTH);
        setCities(response.data.data);
      } catch (err) {
        console.error(err, err.response.data);
      }
    };

    fetchCities();
  }, []);

  const onCreateBranch = async (data) => {
    const createBranchRequest = JSON.stringify({
      store_id: Number(selectedStore.id),
      name: data.storeName,
      address: data.merchantAddressForm,
      city: selectedCity.name,
      province: selectedProvinces.name,
      region: selectedRegion.name,
      disabled: false,
    });

    try {
      const newBranch = await axios.post(
        `${config.branches}`,
        createBranchRequest,
        LOCATION_AUTH
      );
      Store.addNotification({
        title: "SUCCESS",
        message: `New Branch Created`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
      dispatch(actions.onFetchBranches(selectedStore.id));
      close();
    } catch (err) {
      Store.addNotification({
        title: "Error",
        message: `${err.response.data.message.toUpperCase()}`,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid red",
        }}
      >
        <Modal
          open={open}
          onClose={close}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Fade in={open} unmountOnExit>
            <Paper
              elevation={3}
              style={{
                minWidth: "500px",
                minHeight: "300px",
                padding: "1.5rem",
              }}
            >
              <form autoComplete="off" onSubmit={handleSubmit(onCreateBranch)}>
                <h3 style={{ fontSize: "1.5rem", textAlign: "center" }}>
                  Branch Form
                </h3>

                <InputLabel htmlFor="storeName"> Selected Store </InputLabel>
                <FormControl
                  style={{
                    marginBottom: "1.2rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Controller
                    name="selectedStore"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        id="receipt-number"
                        placeholder="Store Name"
                        multiline
                        fullWidth
                        disabled
                      />
                    )}
                  />
                  <p>
                    <em>
                      *disabled must be selected from main processing form
                    </em>
                  </p>
                </FormControl>

                <InputLabel
                  htmlFor="storeName"
                  style={{ marginBottom: ".5rem" }}
                >
                  Branch Name
                </InputLabel>
                <FormControl
                  style={{
                    marginBottom: "1.2rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Controller
                    name="storeName"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        id="receipt-number"
                        placeholder="Store Name"
                        multiline
                        fullWidth
                      />
                    )}
                  />
                  <p>
                    <em>{`Sample Format: MERCURY DRUG - DARAGA RIZAL`}</em>
                  </p>
                </FormControl>

                <InputLabel
                  htmlFor="merchantAddressForm"
                  style={{ marginBottom: ".5rem" }}
                >
                  Address
                </InputLabel>
                <FormControl
                  style={{
                    marginBottom: "1.2rem",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Controller
                    name="merchantAddressForm"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        id="receipt-number"
                        placeholder="Merchant Address"
                        multiline
                        fullWidth
                      />
                    )}
                  />
                </FormControl>

                <InputLabel style={{ marginBottom: ".5rem" }}>City</InputLabel>
                <FormControl
                  style={{
                    marginBottom: "1.2rem",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Autocomplete
                    options={cities}
                    value={selectedCity}
                    onChange={(event, input) => setSelectedCity(input)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        autoComplete="new-user-street-address"
                      />
                    )}
                    getOptionLabel={(city) => {
                      if (city) {
                        return `${city.name} ${city.province} (CODE: ${city.province_code})`;
                      } else {
                        return "Select City";
                      }
                    }}
                    fullWidth
                  />
                </FormControl>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{ marginRight: "1.5rem", fontSize: "1.2rem" }}
                    onClick={close}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ fontSize: "1.2rem" }}
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </Paper>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};

export default AddStoreModal;
